<template>
    <div class="c-user-avatar" :class="{ circle }" :style="avatarStyle">
        <img v-if="pictureUrl" class="picture" :src="pictureUrl" :alt="name" />
        <span v-else class="initials">{{ initials }}</span>
        <slot />
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { getThumbUrl } from '@/utils/imageUtils';

const props = withDefaults(
    defineProps<{
        name?: string;
        picturePath?: string;
        size?: number;
        circle?: boolean;
    }>(),
    { size: 40 }
);

const initials = computed(() => props.name?.toUpperCase().slice(0, 2) ?? '');

const pictureUrl = computed(() => (props.picturePath ? getThumbUrl(props.picturePath) : undefined));

const avatarStyle = computed(() => ({
    width: `${props.size}px`,
    height: `${props.size}px`,
    fontSize: `${props.size * 0.5}px`
}));
</script>

<style lang="scss" scoped>
@import 'styles/utilities/functions';

.c-user-avatar {
    position: relative;
    display: flex;
    flex-shrink: 0;
    justify-content: center;
    align-items: center;
    background-color: get-color('purple');
    color: get-color('white');
    font-weight: bold;
    text-transform: uppercase;
    border-radius: 0.5rem;
    &.circle {
        border-radius: 50%;
    }
    .picture {
        width: 100%;
        height: 100%;
        object-fit: fill;
        border-radius: inherit;
    }
    .initials {
        line-height: 1;
    }
}
</style>
